<template>
  <figure>
    <v-chart :options="lineOption" class="cischart" auto-resize />
  </figure>
</template>
<script>
//* *********************summary***************************//
// html:
// <cisLine :title="title"
// :subTitle="subTitle"
// :x-list="xList"
// :series-name="seriseName"
// :series-data="seriseList" ></cisLine>
//
// js data:
// {
// title: '销量对比图',
// subTitle: '3个月内销量图',
// xList: ['9月','10月','11月'],
// seriseName: ['九阳', '苏泊尔'],
// seriseList: [[133,80,333],[111,222,333]]  //单个系列 [111,222,333]
// }
//* *********************summary***************************//
import 'echarts/lib/chart/line'
export default {
  name: 'cisLine',
  props: ['title', 'subTitle', 'xList', 'seriesData', 'seriesName', 'isSmooth'],
  data() {
    return {
      series: [],
      legends: [],
      unselectedLegends: []
    }
  },
  mounted() {
    this.reloadSeries()
  },
  methods: {
    reloadSeries() {
      this.series = []
      if (this.seriesName && this.seriesName.length >= 1) {
        this.seriesName.forEach((name, index) => {
          this.series.push({
            type: 'line',
            name: name,
            smooth: !!this.isSmooth,
            data: this.seriesData[index]
          })
        })
      } else {
        this.series.push({
          type: 'line',
          smooth: !!this.isSmooth,
          name: this.seriesName,
          data: Array.isArray(this.seriesData[0]) ? this.seriesData[0] : this.seriesData
        })
      }
      this.legends = this.seriesName.map(name => {
        return {
          name,
          icon: 'rect'
        }
      })
    }
  },
  computed: {
    lineOption() {
      this.reloadSeries()
      let scrollLegendOption = {}
      if (this.legends.length > 10) {
        scrollLegendOption = {
          type: 'scroll',
          width: '80%'
        }
      } else {
        scrollLegendOption = {}
      }
      return {
        title: {
          text: this.title,
          subtext: this.subTitle
        },
        legend: {
          data: this.legends,
          ...scrollLegendOption
          // bottom: '0'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'line' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.xList
        },
        yAxis: {
          type: 'value'
        },
        series: this.series
      }
    }
  }
}
</script>
